var urlOpt = {
  qa: "http://localhost:3000/",
  online: "https://api.dreamrail.cn/",
};
var linkType = "online";
// if (process.env.NODE_ENV == "development") {
//   console.log("NODEENV", process.env.NODE_ENV);
//   linkType = "qa";
// }

module.exports = urlOpt[linkType];
